// Should mostly match tailwind.config.js
export enum Color {
  // Grays
  Black = '#000000',
  White = '#FFFFFF',
  Grey = '#888888',

  // Accents
  Yellow = '#FCFF52',
  Red = '#F68098',
  Gypsum = '#FCF6F1',
  Sand = '#E7E3D4',
  Wood = '#655947',
  Lavender = '#B490FF',
  Lilac = '#ccb8f7ff',
  Fig = '#1E002B',
  Mint = '#BEEAA9',
  Jade = '#56DF7C',
  Forest = '#476520',
  Citrus = '#FF9A51',
  Lotus = '#FFA3EB',
  Sky = '#7CC0FF',

  // Colors from former branding
  OldGreen = '#35D07F',
  OldGold = '#FBCC5C',
}

export const CHART_COLORS = [
  Color.Lavender,
  Color.Forest,
  Color.Citrus,
  Color.Lotus,
  Color.Sky,
  Color.Grey,
];
